import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type InventoryLogResponseItem = {
    amount: Maybe<number>
    inventory_transaction_id: string
    location_name: string
    origin_timestamp: string
    user_account_name: string
    unit?: Maybe<string>
}

export const getInventoryLogOfChanges = (
    headers: Record<string, any>,
    inventoryItemId: string,
    locationId: Maybe<string>
): Rx.Observable<InventoryLogResponseItem[]> => {
    const url = locationId
        ? `/data/inventory-item/${inventoryItemId}/restock-transactions?count=5&location_id=${locationId}`
        : `/data/inventory-item/${inventoryItemId}/restock-transactions?count=5`
    return Rx.defer(() =>
        request({
            method: "GET",
            path: url,
            headers: headers,
        })
    ).pipe(retry(3))
}
